<template>
  <div
    v-if="PRODUCTS.length"
    class="product-gallery-recomendations"
  >
    <product-gallery
      :title="title"
      :products="PRODUCTS"
    />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import ProductGallery from '@/components/product-gallery/product-gallery.vue';
import { createGtmEventsProxy } from '@/gtm/gtm-events-utils';
import { productGtmEvents } from '@/gtm/product';
import { ROUTE_NAMES } from '@/router/route-names';

export default {
  components: {
    ProductGallery
  },

  provide() {
    const gtmEvents = {
      [ROUTE_NAMES.Product]: productGtmEvents.recommendations,
    }[this.$route?.name];

    return {
      gtmEvents: createGtmEventsProxy(gtmEvents),
    };
  },

  props: {
    productIds: {
      type: Array,
      required: true,
    },
    title: {
      type: String,
      default: 'С этим товаром покупают'
    }
  },

  computed: {
    ...mapState('productGalleries', {
      PRODUCTS: state => state.recommendations
    }),
  },

  methods: {
    ...mapActions('productGalleries', ['loadRecommendations'])
  },

  serverPrefetch() {
    return this.loadRecommendations(this.productIds);
  },
}
</script>
